import { createAction } from "redux-actions";
import { DashboardConstants } from "./dashboardConstants";

export const fetchDashboard = createAction(DashboardConstants.FETCH_DASHBOARD);
